module.exports = {
      id: "search-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#search",
      toString: function () {
        return this.url;
      }
    }